import { Button, H1, HTMLTable, Icon, Intent } from "@blueprintjs/core";
import * as React from "react";
import { firestore } from "../firebase";
import "../styles/scheduledreports.css";

interface ScheduledReportsState {
  businessNamesKey: any;
  emails: any[];
  loading: boolean;
}
class ScheduledReports extends React.Component<{}, ScheduledReportsState> {
  public state: ScheduledReportsState = {
    businessNamesKey: {},
    emails: [],
    loading: false,
  };

  public async componentDidMount() {
    await this.getNameKey();
    this.getSchedules();
  }

  public render() {
    const { emails, loading } = this.state;
    if (loading) {
      return (
        <div>
          <br />
          <br />
          <br />
          <H1>
            Loading... <Icon className="icon-spin" icon="refresh" iconSize={40} />
          </H1>
        </div>
      );
    }
    return (
      <div style={{ margin: "0 auto" }}>
        <HTMLTable striped={true}>
          <thead>
            <tr>
              <th>Delete</th>
              <th>Email</th>
              <th>Business</th>
              <th>Site</th>
              <th>Type</th>
              <th>Occurence</th>
            </tr>
          </thead>
          <tbody>
            {emails.map((schedule, index) => (
              <tr key={index}>
                <td>
                  <Button onClick={() => this.deleteSchedule(schedule, index)} icon="trash" intent={Intent.DANGER} />
                </td>
                <td>{schedule.map.email}</td>
                <td>{this.getBusinessName(schedule.map.businessId)}</td>
                <td>{schedule.siteName}</td>
                <td>{schedule.map.type}</td>
                <td>{schedule.map.occurence}</td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>
      </div>
    );
  }

  private deleteSchedule(schedule: any, index: number) {
    firestore.doc("report-scheduling/" + schedule.id).delete();
    const arr = this.state.emails;
    arr.splice(index, 1);
    this.setState({ emails: arr });
  }

  private async getSiteName(businessId: string, siteId: string) {
    const query = await firestore.doc("businesses/" + businessId + "/sites/" + siteId).get();
    const data = query.data();
    if (data) {
      // console.log(data.path);
      return data.path;
    }
    return "";
  }

  private getBusinessName(businessId: string) {
    return this.state.businessNamesKey[businessId];
  }

  private async getNameKey() {
    const query = await firestore.collection("businesses").get();
    const names: any = {};
    query.forEach((doc) => {
      const name = doc.data().businessName;
      const id = doc.data().businessId;
      if (names[id]) {
        return;
      } else {
        names[id] = name;
      }
    });
    console.log(names);
    this.setState({ businessNamesKey: names });
  }

  private async getSchedules() {
    this.setState({ loading: true });
    const query = await firestore
      .collection("report-scheduling")
      .orderBy("map.businessId", "asc")
      .get();
    const emails: object[] = [];
    for (const doc of query.docs) {
      const schedules = doc.data();
      schedules.id = doc.id;

      if (schedules.map.siteId && schedules.map.siteId === "all") {
        schedules.siteName = "all";
      } else if (schedules.map.siteId && schedules.map.siteId !== "all") {
        const siteName = await this.getSiteName(schedules.map.businessId, schedules.map.siteId);
        // console.log(siteName);
        schedules.siteName = siteName;
      }

      emails.push(schedules);
    }
    this.setState({ emails, loading: false });
  }
}

export default ScheduledReports;



// WEBPACK FOOTER //
// ./src/views/ScheduledReports.tsx